/**
* 头部菜单
*/
<template>


  <el-menu class="el-menu-demo" mode="horizontal"  text-color="#fff" id="topmenu"   >
    <el-button class="buttonimg">
      <img class="showimg" :src="collapsed?imgsq:imgshow" @click="toggle(collapsed)">
    </el-button>
    <el-submenu index="2" class="topsubmenu" id="topsubmenu"   >
      <template slot="title"   > <i class="el-icon-s-custom"></i> {{user.principal}}</template>

      <el-menu-item  @click="modifypass()" index="2-1"   >
        <i class="el-icon-edit-outline"></i>
        修改密码</el-menu-item>
      <el-menu-item @click="exit()" index="2-2"  >    <i class="el-icon-sold-out"></i>退出</el-menu-item>

    </el-submenu>

  </el-menu>
</template>
<script>
import { loginout } from '../api/userMG'
export default {
  name: 'navcon',
  data() {
    return {
      collapsed: true,
      imgshow: require('../assets/img/show.png'),
      imgsq: require('../assets/img/sq.png'),
      user: {}
    }
  },
  // 创建完毕状态(里面是操作)
  created() {
    this.user = JSON.parse(localStorage.getItem('userdata'))
   // console.log(this.user+"aaaaaaaaaaaaa")
  },
  methods: {
    modifypass(){
      this.$router.push({ path: '/system/modpass' })
    },
    // 退出登录
    exit() {
      this.$confirm('退出登录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          // setTimeout(() => {
          //   this.$store.commit('logout', 'false')
          //   this.$router.push({ path: '/login' })
          //   this.$message({
          //     type: 'success',
          //     message: '已退出登录!'
          //   })
          // }, 1000)

          loginout()
            .then(res => {
              if (res.code=="0") {
                //如果请求成功就让他2秒跳转路由
                setTimeout(() => {
                  this.$store.commit('logout', 'false')
                  this.$router.push({ path: '/login' })
                  this.$message({
                    type: 'success',
                    message: '已退出登录!'
                  })
                }, 1000)
              } else {
                this.$message.error(res.msg)
                this.logining = false
                return false
              }
            })
            .catch(err => {
              // 获取图形验证码
              this.getcode()
              this.logining = false
              this.$message.error('退出失败，请稍后再试！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
    },
    // 切换显示
    toggle(showtype) {
      this.collapsed = !showtype
      this.$root.Bus.$emit('toggle', this.collapsed)
    }
  }
}
</script>
<style scoped>



.el-menu--horizontal .el-menu .el-menu-item, .el-menu--horizontal .el-menu .el-submenu__title

{
  background: #22ddd0 !important;
}


.topsubmenu {
  float: right;
  padding-right: 40px;
}
.buttonimg {
  height: 60px;
  background-color: transparent;
  border: none;
}
.showimg {
  width: 26px;
  height: 26px;
  position: absolute;
  top: 17px;
  left: 17px;
}
.showimg:active {
  border: none;
}

#topmenu{
  border-right: 0 !important;/*去掉element menu的右侧边框 */
  background-image: linear-gradient( to right,  #03e1d1,#22ddd0  ) !important;
  font-weight: 900!important;
}

.el-menu--horizontal .el-menu .el-menu-item:hover{
  background: #c6e2ff !important;
  font-weight: 900!important;
  color:#ecf5ff;
}



#topsubmenu :hover {
  color: #000 ;
  background: #c6e2ff !important ;
}




</style>



// WEBPACK FOOTER //
// src/components/navcon.vue